(function () {
    'use strict';

    // Step configuration
    var STEPS = [
        {
            bg: 'assets/images/onboarding/slide-1.jpg',
            title: 'fajnie, że\u00a0nami jesteś!',
            overlay: 'dark',
            btnLabel: 'Dalej'
        },
        {
            bg: 'assets/images/onboarding/slide-2.jpg',
            title: 'Bonus na start',
            overlay: 'none',
            btnLabel: 'Dalej'
        },
        {
            bg: 'assets/images/onboarding/slide-3.jpg',
            // bgDesktop: 'assets/images/onboarding/bg-3.jpg',
            title: 'Chcesz więcej punktów?',
            overlay: 'none',
            btnLabel: 'Dalej'
        },
        {
            bg: 'assets/images/onboarding/slide-4-mobile.jpg',
            bgDesktop: 'assets/images/onboarding/slide-4.jpg',
            // title: 'Odkrywaj i wygrywaj',
            overlay: 'none',
            btnLabel: 'Odkrywaj i wygrywaj!'
        }
    ];

    var backdrop = null;
    var titleEl = null;
    var progressFill = null;
    var btnEl = null;
    var overlayEl = null;
    var bgLayers = [];
    var stepEls = [];
    var currentStep = 0;
    var isAnimating = false;
    var activeBgIndex = 0;
    var svgTextContainer = null;

    function init() {
        backdrop = document.getElementById('onboarding');
        if (!backdrop) return;

        titleEl = document.getElementById('onboarding-title');
        progressFill = document.getElementById('onboarding-progress-fill');
        btnEl = document.getElementById('onboarding-btn');
        overlayEl = backdrop.querySelector('.onboarding__overlay');
        bgLayers = Array.prototype.slice.call(backdrop.querySelectorAll('.onboarding__bg'));
        stepEls = Array.prototype.slice.call(backdrop.querySelectorAll('.onboarding__step'));

        btnEl.addEventListener('click', onNextClick);
        backdrop.querySelector('.onboarding__close').addEventListener('click', close);

        // Load SVG inline for animation
        svgTextContainer = document.getElementById('onboarding-svg-text');
        if (svgTextContainer) {
            loadSvgInline(svgTextContainer);
        }

        // Info button & alert
        var infoBtn = document.getElementById('onboarding-info-btn');
        var alertEl = document.getElementById('onboarding-alert');
        var alertClose = document.getElementById('onboarding-alert-close');

        if (infoBtn && alertEl) {
            infoBtn.addEventListener('click', function () {
                alertEl.classList.remove('is-dismissing');
                alertEl.classList.toggle('is-visible');
            });
        }
        if (alertClose && alertEl) {
            alertClose.addEventListener('click', function (e) {
                e.stopPropagation(); // prevent global alert-banner.js dismiss
                alertEl.classList.remove('is-visible', 'is-dismissing');
            });
        }

    }

    function show() {
        if (!backdrop) return;
        currentStep = 0;
        activeBgIndex = 0;

        // Set initial state
        setBackground(STEPS[0].bg, true, STEPS[0].bgDesktop);
        setOverlay(STEPS[0].overlay);
        setProgress(0);
        showStep(0, true);

        document.body.classList.add('onboarding-open');
        backdrop.classList.add('is-active');
    }

    function close() {
        if (!backdrop) return;
        backdrop.classList.add('is-dismissing');
        backdrop.classList.remove('is-active');

        setTimeout(function () {
            backdrop.classList.remove('is-dismissing');
            document.body.classList.remove('onboarding-open');
        }, 300);
    }

    function onNextClick() {
        if (isAnimating) return;

        if (currentStep >= STEPS.length - 1) {
            close();
            return;
        }

        goToStep(currentStep + 1);
    }

    function goToStep(nextStep) {
        if (nextStep < 0 || nextStep >= STEPS.length) return;
        if (isAnimating) return;
        isAnimating = true;

        var prevStep = currentStep;
        currentStep = nextStep;
        var stepConfig = STEPS[nextStep];

        // Hide info alert when changing steps
        var alertEl = document.getElementById('onboarding-alert');
        if (alertEl) alertEl.classList.remove('is-visible');

        // 1. Animate background crossfade
        setBackground(stepConfig.bg, false, stepConfig.bgDesktop);

        // 2. Animate overlay
        setOverlay(stepConfig.overlay);

        // 3. Fade out old step
        var oldStepEl = stepEls[prevStep];
        oldStepEl.classList.add('is-leaving');
        oldStepEl.classList.remove('is-active');

        // 4. Update title with fade
        titleEl.style.opacity = '0';
        titleEl.style.transform = 'translateY(10px)';

        // 5. Update progress
        setProgress(nextStep);

        // 6. Update button label
        btnEl.textContent = stepConfig.btnLabel;

        setTimeout(function () {
            // Hide old step
            oldStepEl.classList.remove('is-leaving');

            // Show new step
            var newStepEl = stepEls[nextStep];
            newStepEl.classList.add('is-entering');

            // Reset SVG animation if entering step 3
            if (nextStep === 3) {
                resetSvgAnimation();
            }

            // Force reflow
            void newStepEl.offsetWidth;

            // Update title
            titleEl.textContent = stepConfig.title;

            // Animate in
            requestAnimationFrame(function () {
                newStepEl.classList.add('is-active');
                newStepEl.classList.remove('is-entering');

                titleEl.style.opacity = '1';
                titleEl.style.transform = 'translateY(0)';

                setTimeout(function () {
                    isAnimating = false;
                }, 400);
            });
        }, 350);
    }

    function setBackground(url, immediate, urlDesktop) {
        var targetIndex = activeBgIndex === 0 ? 1 : 0;
        var targetBg = bgLayers[targetIndex];
        var currentBg = bgLayers[activeBgIndex];

        var finalUrl = (urlDesktop && window.matchMedia('(min-width: 769px)').matches) ? urlDesktop : url;
        targetBg.style.backgroundImage = 'url(' + finalUrl + ')';

        if (immediate) {
            // No transition — instant
            targetBg.classList.add('onboarding__bg--active');
            currentBg.classList.remove('onboarding__bg--active');
            activeBgIndex = targetIndex;
        } else {
            // Crossfade transition
            targetBg.classList.add('onboarding__bg--active');

            setTimeout(function () {
                currentBg.classList.remove('onboarding__bg--active');
                activeBgIndex = targetIndex;
            }, 600);
        }
    }

    function setOverlay(type) {
        overlayEl.className = 'onboarding__overlay';
        if (type === 'dark') {
            overlayEl.classList.add('onboarding__overlay--dark');
        } else if (type === 'blue') {
            overlayEl.classList.add('onboarding__overlay--blue');
        }
    }

    function setProgress(step) {
        var percentage = ((step + 1) / STEPS.length) * 100;
        progressFill.style.width = percentage + '%';
    }

    function showStep(index, immediate) {
        stepEls.forEach(function (el, i) {
            if (i === index) {
                el.classList.add('is-active');
                el.classList.remove('is-leaving', 'is-entering');
            } else {
                el.classList.remove('is-active', 'is-leaving', 'is-entering');
            }
        });

        if (titleEl) {
            titleEl.textContent = STEPS[index].title;
            if (immediate) {
                titleEl.style.opacity = '1';
                titleEl.style.transform = 'translateY(0)';
            }
        }

        if (btnEl) {
            btnEl.textContent = STEPS[index].btnLabel;
        }
    }

    // --- SVG inline loader & path animation ---
    function loadSvgInline(container) {
        var src = container.getAttribute('data-src');
        if (!src) return;

        var xhr = new XMLHttpRequest();
        xhr.open('GET', src, true);
        xhr.onload = function () {
            if (xhr.status === 200) {
                container.innerHTML = xhr.responseText;
                // Make SVG responsive: ensure viewBox exists, remove fixed dimensions
                var svgEl = container.querySelector('svg');
                if (svgEl) {
                    if (!svgEl.getAttribute('viewBox')) {
                        var w = svgEl.getAttribute('width') || 338;
                        var h = svgEl.getAttribute('height') || 237;
                        svgEl.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
                    }
                    svgEl.removeAttribute('width');
                    svgEl.removeAttribute('height');
                }
                initSvgPaths(container);
            }
        };
        xhr.send();
    }

    function initSvgPaths(container) {
        var paths = container.querySelectorAll('.svg-letter');
        for (var i = 0; i < paths.length; i++) {
            var len = paths[i].getTotalLength();
            paths[i].style.setProperty('--path-length', len);
        }
    }

    function resetSvgAnimation() {
        if (!svgTextContainer) return;
        var paths = svgTextContainer.querySelectorAll('.svg-letter');
        for (var i = 0; i < paths.length; i++) {
            paths[i].style.animation = 'none';
            // Force reflow
            void paths[i].offsetWidth;
            paths[i].style.animation = '';
        }
    }

    // Public API
    window.Onboarding = {
        init: init,
        show: show,
        close: close,
        goToStep: goToStep
    };

    // Initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
